import { Address as MyleModelsCommonAddress } from "@/Common/Models/Contacts/Address";
import { Guid } from "@/Common/Models/Guid";
import { Email } from "../../Contacts/Dto/Email";
import { FlatLookupView } from "../../MedfarDictionaries/Dto/Responses/FlatLookupView";

class TransferablePatientInfoResponse {
    public ContactId: Guid;
    public ContactFacetId: string;
    public FirstName: string;
    public PreferredName: string;
    public LastName: string;
    public DateOfBirth: Date;
    public MotherFirstName: string;
    public MotherLastName: string;
    public Prefix: TransferableLookup;
    public Gender: TransferableLookup;
    public PreferredSpokenLanguage: TransferableLookup;
    public Addresses: TransferableAddress[];
    public Emails: TransferableEmail[];
    public Phones: TransferablePhone[];
    public HealthIdentifiers: TransferableHealthIdentifier[];

    public constructor(item?: Partial<TransferablePatientInfoResponse>) {
        if (item)
            Object.assign(this, item);
    }
}

class TransferableLookup {
    public Id: string;
    public Code: string;
    public TypeCode: string;

    public constructor(item?: Partial<TransferableLookup>) {
        if (item)
            Object.assign(this, item);
    }

    /** Create a transferable lookup from the given lookup */
    public static fromLookup(lookup: FlatLookupView): TransferableLookup | null {
        return lookup
            ? new TransferableLookup({
                Id: lookup.LookupID,
                Code: lookup.LookupCode,
                TypeCode: lookup.LookupTypeCode
            })
            : null;
    }
}

class TransferableAddress {
    public StreetAddress: string;
    public City: string;
    public PostalCode: string;
    public IsPreferred: boolean;
    public Region: TransferableLookup;
    public Country: TransferableLookup;

    public static toCommonAddress(item: TransferableAddress): MyleModelsCommonAddress {
        const address = new MyleModelsCommonAddress({
            City: item.City,
            ZipCode: item.PostalCode,
            CountryLookupId: item.Country?.Id,
            Country: cacheStore.GetLocalizedValueByLookupId(item.Country?.Id),
            State: cacheStore.GetLocalizedValueByLookupId(item.Region?.Id),
            StateLookupId: item.Region?.Id,
            StreetAddress: item.StreetAddress,
            IsPreferred: item.IsPreferred
        });
        address.validationRule = address.validationHelper.getPostalCodeValidationRule(address.CountryLookupId, null);
        return address;
    }
}

class TransferableEmail {
    public Address: string;
    public IsOkToContact: boolean;
    public ContactType: TransferableLookup;

    public static toCommonEmail(item: TransferableEmail): Email {
        let email = new Email();
        email.Address = item.Address;
        email.IsOkToContact = item.IsOkToContact;

        email.ContactPointTypeLookupId = item.ContactType?.Id;
        return email;
    }
}

class TransferablePhone {
    public PhoneNumber: string;
    public Extension: string;
    public IsPreferred: boolean;
    public Type: TransferableLookup;
    public ContactType: TransferableLookup;
    public Country: TransferableLookup;
}

class TransferableHealthIdentifier {
    public Value: string;
    public ExpiryDate: Date;
    public Province: TransferableLookup;
}

export { TransferableAddress, TransferableEmail, TransferableHealthIdentifier, TransferableLookup, TransferablePatientInfoResponse, TransferablePhone };
